export default __webpack_public_path__ + "static/media/prodotti-main-img.5f383b57.jpg";